import { makeStyles } from '@material-ui/core';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  presentation: {
    diaplay: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: '64px',
  },
  modalPresentation: {
    outline: 'none',
  },
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    width: '100vw',
    height: 'calc(100vh - 64px)', // 64px == toolbar height
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
});

export default useStyles;
